import Fire from '@assets/fire';
import Tag from '@assets/tag';
import { Subtitle2 } from '@components/Texts/Texts';
import tw, { styled } from 'twin.macro';

export const FireSVG = styled(Fire)`
  ${tw`me-1`}
`;

export const TagSVG = styled(Tag)`
  ${tw`me-1`}
`;

export const PriceBadgeStyle = styled(Subtitle2)`
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  ${tw`mt-2 font-semibold text-light-low p-1 flex flex-row w-max absolute end-2 top-0 items-center`}
`;
